import {
  CHANGE_PRE_STATUS,
  EDIT_PRE_USER,
  DELETE_PRE_USER,
  SET_PRE_USER,
  SET_CONTRIBUTOR,
  CHANGE_PRE_MEMBERSHIP,
  ADD_PRE_USER,
  PRE_COURSE_UNENROLL,
  DELETE_CONTRIBUTOR
} from "../constant";

export const deletePreUserById = (payload) => ({
  type: DELETE_PRE_USER,
  payload: payload,
});

export const changePreStatus = (payload) => ({
  type: CHANGE_PRE_STATUS,
  payload: payload,
});

export const changePreMemberShip = (payload) => ({
  type: CHANGE_PRE_MEMBERSHIP,
  payload: payload,
});

export const setPreUser = (payload) => ({
  type: SET_PRE_USER,
  payload: payload,
});

export const setContributor = (payload) => ({
  type: SET_CONTRIBUTOR,
  payload: payload,
});

export const addPreUser = (payload) => ({
  type: ADD_PRE_USER,
  payload: payload,
});

export const editPreUser = (payload) => ({
  type: EDIT_PRE_USER,
  payload: payload,
});

export const preCourseUnenroll = (payload) => ({
  type: PRE_COURSE_UNENROLL,
  payload: payload,
});

export const contributorDelete =  (payload) => ({
  type: DELETE_CONTRIBUTOR,
  payload: payload,
})